<div class="dcf-hero dcf-hero-default">
  <!-- TemplateEndEditable -->
  <div class="dcf-hero-group-1">
    <div class="dcf-breadcrumbs-wrapper">
      <nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
        <!-- TemplateBeginEditable name="breadcrumbs" -->
        <ol>
          <li><a href="https://www.unl.edu/">Nebraska</a></li>
          <li><a href="/">TCAN / VITA Lincoln</a></li>
          <li><a href="/management">Management</a></li>
          <li><span aria-current="page">Queue Management</span></li>
        </ol>
        <!-- TemplateEndEditable -->
      </nav>
    </div>
    <header class="dcf-page-title" id="dcf-page-title">
      <!-- TemplateBeginEditable name="pagetitle" -->
      <h1>Queue Management</h1>
      <!-- TemplateEndEditable -->
    </header>
    <!-- TemplateBeginEditable name="herogroup1" -->
    <!-- TemplateEndEditable -->
  </div>
  <!-- TemplateBeginEditable name="herogroup2" -->
  <div class="dcf-hero-group-2">
  </div>
  <!-- TemplateEndEditable -->
</div>

<div class="dcf-main-content dcf-wrapper">
  <div class="dcf-wrapper dcf-mb-8">
    <!-- Queue Section -->
    <div [hidden]="selectedAppointment != null">
      <!-- Header -->
      <!-- <div class="dcf-grid dcf-grid-thirds dcf-col-gap-2 dcf-mb-6"> -->
      <div id="controls">
        <div>
          <label for="siteSelect" class="dcf-label">Site</label>
          <select id="siteSelect"
            class="dropdown-toggle dcf-w-100% dcf-input-select"
            [(ngModel)]="selectedSite"
            (change)="siteChanged()">
            <option value="0" style="display:none;">-- Select A Site --</option>
            @for (site of sites; track site) {
              <option [value]="site.siteId">{{ site.title }}</option>
            }
          </select>
        </div>

        <div>
          <label for="filterDate" class="dcf-label">Date</label><br />
          <mat-form-field class="example-full-width">
            <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" (ngModelChange)="dateChanged($event)" id="filterDate" >
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker class="dcf-modal dcf-fixed"></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Search box -->
        <div>
          <label for="queueSearch" class="dcf-label">Client Search</label>
          <input type="text"
            id="queueSearch"
            class="dcf-w-100% dcf-input-text"
            [(ngModel)]="clientSearchString" />

          <!-- Message if there are no appointments that match the search -->
          <p class="dcf-txt-center"
            [hidden]="!clientSearchString || parseAppointments('doSomePassSearchFilter', 0)"
            >
            No results for "{{clientSearchString}}".
          </p>
        </div>
      </div><!--  end #controls -->
    <!-- </div> -->
    <!-- End Header -->

    <!-- Shown if no site has been selected -->
    @if (selectedSite == null) {
      <div class="dcf-txt-center">
        Select a site and date.
      </div>
    }


    @for (pool of getPoolList(); track pool) {
      <div [hidden]="!hasAppointments(pool)" class="example-boundary">
        <div class="dcf-grid dcf-grid-fifths@md dcf-col-gap-2">
          <div class="dcf-d-flex dcf-jc-center "><h2 class="queue_header">{{pool['progressionTypeName']}} Queue</h2></div>
          <!-- Swimlane headers -->
          @for (swimlane of pool.swimLanes; track swimlane) {
            <div class="dcf-d-flex dcf-jc-center">
              <h5>{{swimlane['stepName']}} ({{getAppointmentsFromSwimlane(swimlane).length}})</h5>
            </div>
          }
        </div>
        <!-- Swimlanes -->
        <div class="dcf-grid dcf-grid-fifths@md dcf-col-gap-2" cdkDropListGroup>
          @for (swimlane of appointmentPool[pool.progressionTypeId]; track swimlane) {
            <div class="example-container"
              id="{{pool.progressionTypeId+'_'+swimlane.stepOrdinal}}"
              [attr.data-prog-type-id]="pool.progressionTypeId" [attr.data-step-id]="swimlane.stepId"
              [attr.data-step-ordinal]="stepOrdinal" [attr.data-max-ordinal]="stepOrdinal===pool.ProgressionTypeMaxOrdinal"
              > <!-- TODO I think dragula-model needs an array (when I moved appts, I was getting error "a.splice is not a function"), should check if I can just pass in an object. -->
              <h2 class="lane_header">{{swimlane['stepName']}} ({{getAppointmentsFromSwimlane(swimlane).length}})</h2>
              <div
                id="cdk_drop_lane_{{pool.progressionTypeId+'_'+swimlane.stepOrdinal+'_'+swimlane.stepId}}"
                cdkDropList
                cdkDropListSortingDisabled
                [cdkDropListData]="swimlane.appointments"
                class="example-list"
                (cdkDropListDropped)="drop($event, pool)">
                @for (appointment of getAppointmentsFromSwimlane(swimlane); track appointment) {
                  <div
                    class="example-box"
                    [attr.data-appointment-id]="appointment.appointmentId"
                    [hidden]="!passesSearchFilter(appointment)"
              (click)="selectAppointment(appointment, pool.progressionTypeId, 
              swimlane.stepOrdinal, (stepOrdinal===pool.ProgressionTypeMaxOrdinal))"
                    cdkDragBoundary=".example-boundary"
                    cdkDrag>
                    {{appointment.clientName}} ({{appointment.scheduledTime}})
                    @if (appointment.answersByLookup?.translator?.answer != 'No') {
                      Requested Translator ({{appointment.answersByLookup?.otherLanguage?.answer || appointment.language}})
                    }
                    
                    <i
                      [hidden]="getAppointmentSubstepName(appointment) === ''">
                      {{getAppointmentSubstepName(appointment)}}
                    </i>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Shown if there are no appointments -->
    @if (!(selectedSite == 0) && !parseAppointments('areThereAnyAppointments', 0)) {
      <div class="dcf-txt-center">
        There are no appointments on this day at this site.
      </div>
    }
  </div>
  <!-- End of Queue Section -->



  <!-- Appointment Information Section (shown when an appointment is clicked) -->
  @if (selectedAppointment != null) {
    <div class="queue_appointment">
      <!-- Provide a way to get back to the queue -->
      <button type="button" class="dcf-btn dcf-btn-secondary dcf-mb-8" (click)="deselectAppointment()">Back to Queue</button>
      <div class="dcf-mb-4">
        <h2>{{selectedAppointment.name}}</h2>
        <div class="dcf-mb-4">
          @if (selectedAppointment.noShow) {
            <span class="pill pill-red">No-show</span>
          }
          @if (!selectedAppointment.noShow) {
            <span>
              @if (selectedAppointment.walkIn) {
                <span class="pill pill-walk-in">Walk-In</span>
              }
              @for (step of selectedAppointmentStepsForPills; track step) {
                <div class="pill">
                  <span class="pill" [class]="step.stepCompleted ? 'pill-complete': 'pill-incomplete'">{{step.stepName}}</span>
                  @if (step.possibleSubsteps && step.possibleSubsteps.length > 0) {
                    <div>
                      <!-- https://stackoverflow.com/questions/21734524/key-value-pairs-in-ng-options -->
                      <select not-hidden=" step.stepOrdinal <= selectedAppointmentOrdinal"
                        (change)="selectSubstep(step.stepOrdinal)"
                        [(ngModel)]="selectedAppointment.steps[step.stepOrdinal].substepId"
                        >
                        @for (substep of step.possibleSubsteps; track substep) {
                          <option [value]="substep.id">{{ substep.name }}</option>
                        }
                      </select>
                    </div>
                  }
                </div>
              }
            </span>
          }
        </div>
        <div><b>Scheduled Appointment Time: </b>{{selectedAppointment.scheduledTime}}</div>
        <div>
          <span><b>Language:</b> {{selectedAppointment.language}}</span>
        </div>
        <div><b>Requested Translator: </b>{{(selectedAppointment.answersByLookup?.translator?.answer) ?? 'Unspecified'}}</div>
        @if (selectedAppointment.emailAddress != null) {
          <div>
            <span><b>Email:</b> {{selectedAppointment.emailAddress}}</span>
          </div>
        }
        @if (selectedAppointment.phoneNumber != null) {
          <div>
            <span><b>Phone Number:</b> {{selectedAppointment.phoneNumber}}</span>
          </div>
        }
        <!-- <div>
          <span><b>Visa Type:</b> {{(selectedAppointment.visa || "None").trim()}}</span>
        </div> -->
        <div>
          <span><b>Appointment Type:</b> {{selectedAppointment.appointmentType}}</span>
        </div>
      </div>
      <div appointment-notes-area class="dcf-mb-6"></div>
      <div class="dcf-mb-2">
        <h4>Appointment Not Completed:</h4>
        <button class="dcf-btn dcf-btn-primary"
          [hidden]="selectedAppointmentOrdinal != 0"
          [disabled]="selectedAppointmentOnLastStep"
          (click)="markAppointmentAsCancelled(selectedAppointment.appointmentId)">
          Cancel Appointment
        </button>
        <button class="dcf-btn dcf-btn-primary"
          [hidden]="selectedAppointmentOrdinal == 0"
          [disabled]="selectedAppointmentOnLastStep"
          (click)="markAppointmentAsIncomplete(selectedAppointment.appointmentId)">
          Mark as Incomplete
        </button>
      </div>
      <div class=" dcf-txt-xs dcf-txt-right"><b>Appointment ID: </b>{{ selectedAppointment.appointmentId }}</div>
    </div>
  }
  <!-- End of Appointment Information Section -->

</div>
</div>